import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";
import { toast } from "react-toastify";

//CUSTOM COMPONENT
import Area from "../../../aGlobalDesign/Area/Area";
import PaginationList from "../../../aGlobalDesign/Pagination/PaginationList";
import ButtonSkaRound from "../../../aGlobalDesign/Buttons/ButtonSkaRound";
import Modal from "../../../aGlobalDesign/Modal/Modal";
import Status from "../../../aGlobalDesign/Status/Status";

class UsersList extends React.Component {

    constructor() {
        super();
        this.state = {
            selectedUser: null,
            forcePaginationUpdate: 0,
            temporaryElement: null,
            agentsFilteredByCallCenter: [],
            organisationUserGroups: [],
            reload: new URLSearchParams(new URL(window.location.href).search).get("reload")
        };
    }

    componentDidMount() {
        this.props.changeAppBarTitle(strings.UsersList);
        this.props.ChangeCurrentMenuName("UsersList");
        if (!this.props.administration.secondaryusergroups) {
            this.props.GetSecondaryUserGroupsList((data) => {
                this.setState({ organisationUserGroups: data.results });
            });
        }
        else {
            this.setState({ organisationUserGroups: this.props.administration.secondaryusergroups.results });
        }
        if (!this.props.monitoring.secondarycallcenters) {
            this.props.GetSecondaryCallCentersList((data) => {});
        }
        if (!this.props.monitoring.secondaryportalagents) {
            this.props.GetSecondaryPortalAgentsList();
        }
    }
    forcePaginationUpdate = () => {
        this.setState(s => ({
            selectedUser: null,
            forcePaginationUpdate: s.forcePaginationUpdate + 1
        }));
    };

    componentDidUpdate(prevProps) {
        if (prevProps.reload !== this.props.reload) {
            this.forcePaginationUpdate();
        }
    }


    getAgentsList(callCenterId) {
        if (!callCenterId) {return;}

        this.props.GetCallCenterById((data) => {
            this.setState({ agentsFilteredByCallCenter: { results: data.results.portalAgents } });
        }, callCenterId);
    }

    //#region functions
    OnSwitchDisableUser(user, onSuccess) {
        const isDisabled = !user.organizationUser.isDisabled;
        const organizationUser = {
            organizationId: this.props.currentuser.currentorganization.id,
            organization: null,
            userId: user.id,
            user: null,
            callCenterId: user.organizationUser.callCenterId,
            portalAgentId: user.organizationUser.portalAgentId,
            displayName: user.organizationUser.displayName,
            isDisabled: isDisabled,
            isInvitationPending: user.organizationUser.isInvitationPending,
            isOrganizationAdministrator: user.organizationUser.isOrganizationAdministrator
        };
        //Save Change To DB
        this.props.EditOrganizationUser(organizationUser, (data) => {
            onSuccess ? onSuccess(data) : null;
            this.forcePaginationUpdate();
        });
    }

    OnLoadUserClick(user) {
        const temp = this.CreateTemp(user);
        this.setState({
            selectedUser: user,
            temporaryElement: temp
        });
        if (temp.callCenterId) {
            this.getAgentsList(temp.callCenterId);
        }
    }
    CreateTemp(element) {
        const temp = {
            id: element.id,
            callCenterId: element.organizationUser.callCenterId,
            portalAgentId: element.organizationUser.portalAgentId,
            isDisabled: element.organizationUser.isDisabled,
            isInvitationPending: element.organizationUser.isInvitationPending,
            isOrganizationAdministrator: element.organizationUser.isOrganizationAdministrator,
            displayName: element.organizationUser.displayName,
            codeAgent: element.organizationUser.codeAgent,
            email: element.email,
            userGroups: element.userGroups,
            userGroupMemberships: element.userGroupMemberships
        };
        return temp;
    }
    SaveTemp(temp, element) {
        element.organizationUser.callCenterId = temp.callCenterId;
        element.organizationUser.portalAgentId = temp.portalAgentId;
        element.organizationUser.displayName = temp.displayName;
        element.organizationUser.codeAgent = temp.codeAgent;
        element.email = temp.email;
        return element;
    }
    onAddUserGroup(element) {
        const user = this.state.temporaryElement;

        //Change here
        const userGroupToAdd = {
            id: element.id,
            lockAccessRights: element.lockAccessRights,
            lockContentPermissions: element.lockContentPermissions,
            lockUserGroupMembership: element.lockUserGroupMembership,
            userGroupPermissions: element.userGroupPermissions,
            name: element.name
        };
        user.userGroups = [userGroupToAdd];
        user.userGroupMemberships = [{
            userId: user.id,
            userGroupId: element.id
        }];
        this.setState({ temporaryElement: user });
    }
    OnSaveUserClick() {
        if (this.state.temporaryElement.email === null || this.state.temporaryElement.email === "") {
            this.props.OpenDialog({
                description: strings.emailNeeded,
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }

        const changedElement = this.state.selectedUser;
        const oldUGId = this.getMainUserGroupId(changedElement.userGroups);
        const newUGId = this.getMainUserGroupId(this.state.temporaryElement.userGroups);
        this.SaveTemp(this.state.temporaryElement, changedElement);

        if (changedElement.id !== 0) {
            const organizationUser = {
                organizationId: this.props.currentuser.currentorganization.id,
                organization: null,
                userId: changedElement.id,
                user: null,
                callCenterId: changedElement.organizationUser.callCenterId,
                zone: null,
                codeAgent: changedElement.organizationUser.codeAgent,
                portalAgentId: changedElement.organizationUser.portalAgentId,
                portalAgent: null,
                isDisabled: changedElement.organizationUser.isDisabled,
                isInvitationPending: changedElement.organizationUser.isInvitationPending,
                isOrganizationAdministrator: changedElement.organizationUser.isOrganizationAdministrator,
                displayName: changedElement.organizationUser.displayName
            };

            if (oldUGId !== newUGId) {
                const userGroupMembership = {
                    userId: changedElement.id,
                    user: null,
                    userGroupId: newUGId,
                    userGroup: null
                };
                this.props.CreateUserGroupMembership(userGroupMembership, () => {
                    this.props.EditOrganizationUser(organizationUser, () => {
                        toast.success(strings.uSaved);
                        this.setState({
                            selectedUser: null,
                            preview: false
                        });
                        if (organizationUser.userId === this.props.currentuser.user.id) {
                            //we changed our own account -> we need to relogin to the application
                            window.location.reload();
                        }
                        else {
                            this.forcePaginationUpdate();
                            this.props.GetSecondaryUsersList((data) => {});
                        }
                    });
                });
            }
            else {
                this.props.EditOrganizationUser(organizationUser, () => {
                    toast.success(strings.uSaved);
                    this.setState({
                        selectedUser: null,
                        preview: false
                    });
                    if (organizationUser.userId === this.props.currentuser.user.id) {
                    //we changed our own account -> we need to relogin to the application
                        window.location.reload();
                    }
                    else {
                        this.forcePaginationUpdate();
                        this.props.GetSecondaryUsersList((data) => {});
                    }
                });
            }
        }
    }

    OnRemoveUser(user, onSuccess) {
        this.props.OpenDialog({
            title: strings.deleteConfirm,
            description: strings.textDeleteItem,
            secondaryLabel: strings.cancel,
            primaryLabel: strings.confirmDelete,
            onPrimaryAction: () => {
                this.props.RemoveOrganizationUser(this.props.currentuser.currentorganization.id, user.id, (data) => {
                    onSuccess ? onSuccess(data) : null;
                    this.forcePaginationUpdate();
                    this.props.GetSecondaryUsersList((data) => {});
                });
            }
        });
    }
    GetNonAttributedPortalAgents(list) {
        const temp = {};
        if (list && list.results) {
            const newlist = [];
            list.results.forEach(pa => {
                if (pa.users !== null && pa.users !== undefined && pa.users.length > 0 && pa.users[0].userId !== this.state.selectedUser.id) {
                    //there is already another user linked to this -> we cannot link it to this one.
                }
                else {
                    newlist.push(pa);
                }
            });
            temp.results = newlist;
        }
        return temp;
    }
    getMainUserGroupName(list) {
        if (list.length <= 0) {return "";}
        if (list.some(ug => ug.name === "Admin")) {return "Admin";}
        if (list.some(ug => ug.name === "Manager")) {return "Manager";}
        const defaulIndex = list.findIndex(u => u.name !== "Agent");
        if (defaulIndex < 0) {return list[0].name;}
        else {return list[defaulIndex].name;}
    }
    getMainUserGroupId(list) {
        if (list.length <= 0) {return null;}
        if (list.length > 1) {return list.find(ug => ug.name !== "Agent").id;}
        else {return list[0].id;}
    }
    OnLogoutUser(user) {
        this.props.OpenDialog({
            title: strings.logoutUser,
            description: strings.messageLogoutUser,
            secondaryLabel: strings.cancel,
            primaryLabel: strings.confirmLogout,
            onPrimaryAction: () => {
                this.props.ForceLogout(user.id, () => {
                    this.forcePaginationUpdate();
                });
            }
        });
    }
    //#endregion

    render() {
        const orgId = this.props.currentuser.currentorganization.id;
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : {};
        const isSystemAdministrator = this.props.currentuser && this.props.currentuser.user && this.props.currentuser.user.isSystemAdministrator;
        return <>
            <PaginationList
                forcePaginationUpdate={this.state.forcePaginationUpdate}

                onGetElements={this.props.GetUsersList}
                onSavePagination={this.props.SaveUsersPagination}
                myElements={this.props.administration.users}

                sortOptions={[
                    { sortName: "email", sortData: "asc" },
                    { sortName: "callcenter", sortData: "null" }
                ]}

                tableElement={(element) => {
                    return [
                        {
                            colTitle: strings.SortStatus,
                            fixedWidth: "84px",
                            lockWidth: true,
                            cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                const value = data[column.field];
                                if (value) {
                                    return <Status statusId={value.statusId}/>;
                                }
                                else {return "";}
                            },
                            colContent: element ? { statusId: this.props.currentuser.user.id === element.id || element.organizationUser.connectionStatus === true ? "60" : "10" } : null
                        },
                        {
                            colTitle: strings.agent,
                            sortIndex: 0,
                            fixedWidth: "200px",
                            colContent: element ? element.organizationUser.displayName : null
                        },
                        {
                            colTitle: strings.SortRole,
                            fixedWidth: "150px",
                            colContent: element && element.userGroups && this.state.organisationUserGroups ?
                                this.getMainUserGroupName(element.userGroups) : null
                        },
                        {
                            colTitle: strings.CallCenter,
                            sortIndex: 1,
                            fixedWidth: "300px",
                            colContent: element && element.organizationUser.callCenterId && this.props.monitoring.secondarycallcenters ?
                                this.props.monitoring.secondarycallcenters.results.find(z => z.id === element.organizationUser.callCenterId).name : null
                        },
                        {
                            colTitle: strings.actions,
                            colType: "actions",
                            actions: isSystemAdministrator ? [1, 2, 3, 4] : [1, 2, 3],
                            colContent: [
                                accessrights && accessrights.hasPermission(200, "modify") > 10 ?
                                    <ButtonSkaRound
                                        key={"logout"}
                                        type="primary"
                                        isDisabled={!element || this.props.currentuser.user.id === element.id || element.organizationUser.connectionStatus !== true}
                                        nameIcon="logout"
                                        onClick={() => this.OnLogoutUser(element)}
                                    /> : null,
                                <ButtonSkaRound
                                    key={"view"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(200, "consult") <= 10 }
                                    nameIcon="eye"
                                    onClick={() => {
                                        this.setState({ preview: true });
                                        this.OnLoadUserClick(element);
                                    }}
                                />,
                                <ButtonSkaRound
                                    key={"edit"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(200, "modify") <= 10 }
                                    nameIcon="edit"
                                    onClick={() => this.OnLoadUserClick(element)}
                                />,
                                <ButtonSkaRound
                                    key={"trash"}
                                    isDisabled={!element || !accessrights || accessrights.hasPermission(200, "delete") <= 10 || element.organizationUser.isOrganizationAdministrator || element.id === this.props.currentuser.user.id
                                        || element.id === this.props.currentuser.user.id ? true : false}
                                    type="primary"
                                    nameIcon="trash"
                                    onClick={() => this.OnRemoveUser(element)}
                                />
                            ]
                        }
                    ];
                }}
            />
            <Modal open={this.state.selectedUser !== null}
                onClose={() => {
                    if (!this.state.preview) {
                        this.forcePaginationUpdate();
                    }
                    else {
                        this.setState({
                            selectedUser: null,
                            preview: false
                        });
                    }
                }}
                title={this.state.preview ? strings.user : strings.editUser}
                icon={this.state.preview ? "information" : "edit"}
                fields={
                    this.state.selectedUser ? [
                        {
                            type: "textfield",
                            title: strings.name,
                            placeholder: strings.name,
                            value: this.state.temporaryElement.displayName,
                            disabled: this.state.preview,
                            onChange: (e) => {
                                const su = this.state.temporaryElement;
                                su.displayName = e.target.value;
                                this.setState({ temporaryElement: su });
                            }
                        },
                        {
                            type: "textfield",
                            title: strings.email,
                            placeholder: "@sncf.fr",
                            value: this.state.temporaryElement.email,
                            disabled: this.state.preview || this.state.temporaryElement.id !== 0,
                            onChange: (e) => {
                                const su = this.state.temporaryElement;
                                su.email = e.target.value;
                                this.setState({ temporaryElement: su });
                            }
                        },
                        {
                            type: "selectElement",
                            title: strings.userGroups,
                            preventEmpty: true,
                            openTop: true,
                            adjustHeight: true,
                            disabled: this.state.preview || this.state.selectedUser.organizationUser.isOrganizationAdministrator,
                            elementsList: { results: this.state.organisationUserGroups },
                            selectedElementId: this.getMainUserGroupId(this.state.temporaryElement.userGroups),
                            onSelectElement: (element) => {
                                if (element != null) {
                                    this.onAddUserGroup(element);
                                }
                            }
                        },
                        {
                            type: "selectElement",
                            title: strings.CallCenter,
                            openTop: true,
                            disabled: this.state.preview,
                            elementsList: this.props.monitoring.secondarycallcenters,
                            selectedElementId: this.state.temporaryElement.callCenterId,
                            onSelectElement: (element) => {
                                const temp = this.state.temporaryElement;

                                if (accessrights.hasPermission(210, "modify") === 20) {
                                    const cucallCenterId = this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId).callCenterId;
                                    if (element && element.id !== cucallCenterId) {return;}
                                }
                                temp.callCenterId = element ? element.id : null;
                                // Clean portalAgentId for each change callCenterId
                                temp.portalAgentId = null;

                                this.setState({
                                    temporaryElement: temp,
                                    // Clean agentsFilteredByCallCenter for each change callCenterId
                                    agentsFilteredByCallCenter: { results: [] }
                                });

                                // Wait call getAgentsList for let dropdown cleaning his DOM
                                setTimeout(() => {
                                    if (element.id) {this.getAgentsList(element.id);}
                                }, 0);
                            }
                        }
                    ] : null
                }
                onValidate={ !this.state.preview ? () => this.OnSaveUserClick() : null }
            >
            </Modal>
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(UsersList);
